import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BackgroundImageUploader } from './BackgroundImageUploader';
import { Image } from 'lucide-react';

export const AdminPageBackgroundManager = () => {
  const [activeTab, setActiveTab] = useState('home');

  const pages = [
    { id: 'home', label: 'Home Page' },
    { id: 'about', label: 'About Page' },
    { id: 'start', label: 'Start Page (FB Ads)' }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Image className="h-5 w-5" />
          Page Background Management
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid w-full grid-cols-3">
            {pages.map((page) => (
              <TabsTrigger key={page.id} value={page.id}>
                {page.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {pages.map((page) => (
            <TabsContent key={page.id} value={page.id}>
              <BackgroundImageUploader 
                page={page.id}
                onImageSaved={() => {
                  // Notify that the background has changed
                  window.dispatchEvent(new Event('background-changed'));
                }}
              />
            </TabsContent>
          ))}
        </Tabs>
      </CardContent>
    </Card>
  );
};